// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    VIDEO_PAGE_LOADING() {
      return {
        isLoading: true,
        videoPage: action.videoPage
      };
    },
    VIDEO_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.videoPage
      };
    },
    VIDEO_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.videoPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
